export const COOKIE_CONSENT = "cookie-consent";
export const CHAT_BOT = "chat-bot";
export const FEEDBACK_FORM = "feedback-enabled";
export const SWEDBANK_API = "swedbank-api";

